/**
 * @file WmsSkuPickerRow.tsx
 * @description Строка фасовки в складском пикере (phase19.13 этап 0).
 *
 * Первая строка — товар и фасовка, вторая — артикул и объём: кладовщик
 * сверяет позицию с этикеткой по коду. Высота ≥56px (warehouse-UI).
 */

import type { WmsPickerSku } from "./WmsSkuPickerDialog";
import { formatPickerSkuName } from "../../lib/api-wms";
import { formatSalePackage } from "../../lib/qty-input";

interface Props {
  sku: WmsPickerSku;
  checked: boolean;
  /** Уже добавлена в документ — выбрать нельзя. */
  disabled: boolean;
  onToggle: () => void;
}

export function WmsSkuPickerRow({ sku, checked, disabled, onToggle }: Props) {
  return (
    <li>
      <label
        className={`flex min-h-[56px] cursor-pointer items-center gap-3 px-4 py-2 transition hover:bg-on-surface/5 ${
          disabled ? "opacity-50" : ""
        } ${checked ? "bg-primary/10" : ""}`}
      >
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={onToggle}
          className="size-5 shrink-0 accent-primary"
          aria-label={`Выбрать ${sku.productName}`}
        />
        <div className="flex min-w-0 flex-1 flex-col">
          <span className="truncate text-sm font-medium">
            {formatPickerSkuName(sku)}
          </span>
          <span className="truncate font-mono text-xs text-on-surface-variant">
            {sku.code}
            {/* Фасовка через реестр единиц: «50 г», не «50.000 g» (TD-53). */}
            {sku.saleQuantity && sku.saleUnit
              ? ` · ${formatSalePackage(sku.saleQuantity, sku.saleUnit)}`
              : ""}
            {disabled ? " · уже добавлена" : ""}
          </span>
        </div>
      </label>
    </li>
  );
}
